module.exports = __webpack_public_path__ + "static/media/checkmark.8b4d781a.svg";